import { Common } from "@components/common/CommonTypes";
import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import PickDateRange, { PickDateRangeResult } from "@components/popups/PickDateRange";
import ValueSelector from "@components/popups/ValueSelector";
import GS from "@root/ts/GlobalSetting";
import { Emitter } from "strict-event-emitter";
import { Search } from "../search/SearchTypes";
import SearchManager from "../search/SearchManager";

export const ORDER_LIST =
  [
    {
      value: "熱門活動",
      text: "熱門活動"
    },

    {
      value: "上架時間",
      text: "上架時間"
    },

    {
      value: "用戶評價",
      text: "用戶評價"
    },

    {
      value: "價格：高到低",
      text: "價格：高到低"
    },

    {
      value: "價格：低到高",
      text: "價格：低到高"
    }
  ];

export default class SearchbarPrototype extends ComponentBase
{
  startDate: moment.Moment;
  endDate: moment.Moment;

  _keywordInputElem: HTMLInputElement;
  _dateInputElem: HTMLInputElement;
  _sortInputElem: HTMLInputElement;

  input: Search.SearchInput =
    {
      order: ORDER_LIST[0].value,
      keyword: "",
      sort: ""
    };

  emitter: Emitter<{ change: [changeType: Search.SearchInputTypes] }>

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();

    this._setupKeywordInput();
    this._setupSortInput();
    this._setupDateInput();
    
  }

  _setupKeywordInput()
  {    
    this._keywordInputElem = this.$root.find(`[data-target="keyword"] input`)[0] as HTMLInputElement;
    this._keywordInputElem.maxLength = GS.search.keywordMaxLength;
    this._keywordInputElem.value = "";

    this._keywordInputElem.addEventListener("keypress", (event)=>
    {
      if (event.key === "Enter") {
        event.preventDefault();
        this._keywordInputElem.blur();
      }
    });

    this._keywordInputElem.addEventListener("blur", ()=>
    { 
      
      let oldValue = this.input.keyword;
      if(oldValue === undefined) oldValue = "";
      
      // console.log(`old: ${oldValue}, new: ${this._keywordInputElem.value}`);

      this.input.keyword = this._keywordInputElem.value;
      if(this.input.keyword !== oldValue) this.emitter.emit("change", "keyword");
    });
  }

  _setupSortInput()
  {
    let self = this,
      $btn = this.$root.find(`.bar[data-target="sort"]`),
      input = this._sortInputElem = $btn.find(`input`)[0];

    input.value = "";

    let valueList = Common.getSortValueList();    

    $btn.on("click", (event: Event) =>
    {
      event.preventDefault();

      ValueSelector.instance.show(valueList, $btn[0]).then((result?: {value: Common.SortData, text: string})=>
      {
        if(result)
        {
          let data = result.value;
          let oldValue = self.input.sort;
          if(oldValue === undefined) oldValue = "";
  
          input.value = data.name;
          self.input.sort = data.name;

          
      
          console.log(`old: ${oldValue}, new: ${self.input.sort}`);
    
          if (self.input.sort !== oldValue) {
            self.emitter.emit("change", "sort");
          }
        }
      });
    });
  }

  _setupDateInput()
  {
    let $field = this.$root.find('[data-target="date"]'),
      input: HTMLInputElement = this._dateInputElem = $field.find("input")[0];

    input.value = "";

    $field.on("click", (event: Event) =>
    {
      event.preventDefault();

      PickDateRange.instance.request(input, this.startDate, this.endDate).then((result: PickDateRangeResult) =>
      {
        if(!result) return;

        let oldStartDate = this.input.start_date,
          oldEndDate = this.input.end_date;

        if (result.isReset) {
          this.startDate = null;
          this.endDate = null;
          this.input.start_date = undefined;
          this.input.end_date = undefined;
        }
        else {
          this.startDate = result.start;
          this.endDate = result.end;

          this.input.start_date = result.start.format(GS.DATE_FORMAT);
          this.input.end_date = result.end.format(GS.DATE_FORMAT);
        }

        this._updateDateText();

        if (this.input.start_date !== oldStartDate || this.input.end_date !== oldEndDate) this.emitter.emit("change", "date");
      });      

    });
  }

  _updateDateText()
  {
    if(this.startDate && this.endDate)
    {
      this._dateInputElem.value = SearchManager.getDateText(this.startDate, this.endDate);
    }
    else
    {
      this._dateInputElem.value = "";
    }
  }
}